
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sangjo/closed/[id]/introduce",
      function () {
        return require("private-next-pages/sangjo/closed/[id]/introduce.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sangjo/closed/[id]/introduce"])
      });
    }
  